import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Document } from '../../types/document';
import { PDFDocumentProxy } from 'pdfjs-dist';
import { ModalBasicComponent } from '../modal-basic/modal-basic.component';
import { NotificationService } from '../../services/notification.service';
import { DocumentUtils } from './services/document-utils';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-document-display',
  templateUrl: './document-display-component.html',
  styleUrls: ['./document-display-component.css'],
  providers: [DocumentUtils],
})
export class DocumentDisplayComponent implements OnInit, OnDestroy {
  @Input() called?: Subject<any>;
  _document: Document;
  showPreview: boolean;
  showModal: boolean;
  pdfTotalPages: number;
  pdfCurrentPage: number;
  loading: boolean;
  @ViewChild('displayDocumentModal', { static: false }) displayDocumentModal: ModalBasicComponent;

  constructor(private store: DocumentUtils, public notificationService: NotificationService) {}

  ngOnDestroy(): void {
    this.called.complete();
  }

  ngOnInit(): void {
    this.loading = false;
    this.called.subscribe((res) => {
      this._document = res.document;
      this.showPreview = res.preview;
      this.showModal = res.showModal;
      if (!this.showPreview && this.showModal) {
        this.onModalDisplay();
      }
    });
  }

  onPdfError(): void {
    this.loading = false;
    this.displayDocumentModal.hide();
    this.notificationService.notifyError('ERROR_OCCURRED');
  }

  onPdfRendered(): void {
    this.loading = false;
  }

  resetModal() {
    this.loading = false;
  }

  printDocument(): void {
    this.store.print(this._document);
  }

  downloadDocument(): void {
    this.store.download(this._document);
  }

  onModalDisplay() {
    this.pdfCurrentPage = 1;
    this.displayDocumentModal.show();
  }

  resetFile(): void {
    this.displayDocumentModal.hide();
  }

  initPDFPagination(pdf: PDFDocumentProxy): void {
    this.pdfTotalPages = pdf.numPages;
  }

  previousPage(): void {
    this.pdfCurrentPage--;
  }

  nextPage(): void {
    this.pdfCurrentPage++;
  }

  onCloseModal(): void {
    this.loading = false;
    this.displayDocumentModal.hide();
  }
}
